export default __webpack_public_path__ + "static/media/Print-02.b5dce010.svg";